import React, { useState } from "react";
import { FaLinkedin, FaInstagram, FaTwitter, FaGithub } from "react-icons/fa";
import { HiMail } from "react-icons/hi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SEO from "../components/SEO";
import "./Home.css";

function Team() {
  const teamMembers = [
    {
      name: "Prakash Choudhary",
      role: "Founder & CEO",
      skills: "Web Development & Machine Learning Expert",
      description: "Leading product development and market strategy. Driving innovation in hospitality tech.",
      image: "/images/PrakashPhoto.jpeg",
      linkedin: "https://www.linkedin.com/in/codepc",
      instagram: "https://www.instagram.com/pc_daukiya",
      email: "prakash@trivanahospitality.com",
      achievements: "10+ Years Experience",
    },
    {
      name: "Nikhil Banthia",
      role: "Founder & CFO",
      skills: "Finance & Business Strategy Expert",
      description: "Managing finances and market analysis. Ensuring sustainable growth.",
      image: "/images/NikhilPhoto.jpeg",
      linkedin: "https://www.linkedin.com/in/nikhil-banthia",
      instagram: "https://www.instagram.com/nikhil_banthia",
      email: "nikhil@trivanahospitality.com",
      achievements: "Strategic Planning",
    },
    {
      name: "Pankaj Kumawat",
      role: "Full Stack Developer",
      skills: "Backend Development & Cloud Infrastructure Specialist",
      description: "Building scalable architecture and leading technical innovations.",
      image: "/images/pankaj-photo2.jpg",
      linkedin: "https://www.linkedin.com/in/pankaj-kumawat-78395b306/",
      instagram: "https://www.instagram.com/pankajkumawat_pk/",
      email: "pankaj@trivanahospitality.com",
      achievements: "Tech Leadership",
    },
    {
      name: "Piyush Purohit",
      role: "Full Stack Developer",
      skills: "Frontend and Backend Development Specialist",
      description: "Crafting beautiful user experiences and responsive interfaces.",
      image: "/images/piyushimg.jpg",
      linkedin: "https://www.linkedin.com/in/piyush-purohit-qs5474/",
      instagram: "https://www.instagram.com/piyush._.peeyush/",
      email: "piyush@trivanahospitality.com",
      achievements: "Design Excellence",
    },
    {
      name: "Kritika Paliwal",
      role: "Chief Graphic Designer",
      skills: "Graphic Design & Brand Identity Expert",
      description: "Creating impactful visuals and leading brand design strategy.",
      image: "/images/KritikaPhoto.jpg",
      linkedin: "https://www.linkedin.com/in/kritika-paliwal-865b26291/",
      instagram: "https://www.instagram.com/k_paliwal15/",
      email: "kritika@trivanahospitality.com",
      achievements: "Creative Direction",
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 550,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3200,
    pauseOnHover: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    arrows: false,
  };

  return (
    <div className="bg-gray-50">
      <SEO 
        title="Meet Our Team - Trivana Hospitality Leadership"
        description="Meet the innovative minds behind Trivana Hospitality. Our expert team of developers, designers, and strategists working to transform the hospitality industry."
        keywords="Trivana team, hospitality tech team, startup founders, tech leadership, Prakash Choudhary, Nikhil Banthia, Pankaj Kumawat"
        url="/team"
      />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <div className="animate-fade-in-up">
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-[#4299f5]/20 to-[#2d7dd1]/20 text-[#4299f5] rounded-full font-semibold text-sm mb-6 border border-[#4299f5]/30">
            Meet The Team
          </div>
          <h1 className="text-5xl font-extrabold sm:text-6xl mb-6 text-white" style={{fontFamily: 'Montserrat, sans-serif'}}>
            The Force Behind <span className="text-[#4299f5]">Trivana</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8 px-4">
            A passionate team of innovators dedicated to revolutionizing hospitality management
          </p>
          </div>

          {/* Team Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mt-12 animate-fade-in-up delay-200">
            {[
              { number: "5+", label: "Team Members" },
              { number: "10+", label: "Years Combined Exp" },
              { number: "500+", label: "Happy Clients" },
              { number: "24/7", label: "Support" }
            ].map((stat, idx) => (
              <div key={idx} className="bg-gray-800 rounded-xl p-6 shadow-xl hover:shadow-[#4299f5]/20 hover:scale-105 transition-all duration-300 border border-gray-700">
                <div className="text-4xl font-extrabold text-[#4299f5] mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>{stat.number}</div>
                <p className="text-sm text-gray-300 font-medium">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
        {/* Decorative elements */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-[#4299f5]/20 rounded-full blur-3xl animate-blob"></div>
        <div className="absolute bottom-20 right-10 w-60 h-60 bg-[#4299f5]/20 rounded-full blur-3xl animate-blob animation-delay-2000"></div>
      </section>

      {/* Mission & Vision */}
      <section className="bg-gray-50 py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 animate-fade-in-up delay-300">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 text-center md:text-left">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] shadow-lg mb-4 mx-auto md:mx-0">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>Our Mission</h3>
              <p className="text-lg text-gray-600">
                To empower hospitality businesses with cutting-edge technology that simplifies operations and drives growth.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5] transform hover:-translate-y-1 transition-all duration-300 text-center md:text-left">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#4299f5] to-[#2d7dd1] shadow-lg mb-4 mx-auto md:mx-0">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>Our Vision</h3>
              <p className="text-lg text-gray-600">
                To become India's leading hospitality management platform, trusted by thousands nationwide.
              </p>
            </div>
          </div>
        </div>
      </section>

    <section className="bg-gray-50 py-16 px-4">
      <div className="max-w-7xl mx-auto text-center">
        {/* Decorative Header */}
        <div className="flex flex-col items-center mb-12 animate-fade-in-up">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Meet Our <span className="text-[#4299f5]">Team Members</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The minds behind Trivana Hospitality LLP
          </p>
        </div>
        {/* Slider */}
        <Slider {...sliderSettings}>
          {teamMembers.map((member, index) => (
            <div key={index}>
              <div className="flex flex-col items-center justify-center px-2 py-2 sm:px-4 sm:py-6 h-full">
                <div
                  className="relative bg-white
                             p-3 sm:p-5 rounded-xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-[#4299f5]
                             transform hover:-translate-y-1 transition-all duration-300 group w-full max-w-[280px] sm:max-w-[340px] mx-auto
                             flex flex-col min-h-[320px] sm:min-h-[380px]"
                >
                  {/* Avatar block (fixed vertical space) */}
                  <div className="flex flex-col items-center">
                    <div className="relative mb-2 sm:mb-3 h-20 sm:h-28 flex items-center justify-center">
                      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <span className="block w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gradient-to-tr from-[#4299f5] via-[#3a8fe5] to-[#2d7dd1] opacity-30 blur-md animate-pulse"></span>
                      </div>
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-[#4299f5] shadow-lg group-hover:scale-105 transition-transform duration-500 relative z-10"
                      />
                      <span className="absolute bottom-0.5 right-0.5 sm:bottom-1 sm:right-1 w-3 h-3 sm:w-3.5 sm:h-3.5 bg-[#4299f5] rounded-full border-2 border-white z-10"></span>
                    </div>
                    <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-0.5 sm:mb-1 group-hover:text-[#4299f5] transition-colors text-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      {member.name}
                    </h3>
                    <p className="text-[#4299f5] text-xs sm:text-sm font-medium mb-1 sm:mb-1.5 text-center">
                      {member.role}
                    </p>
                    <p className="text-gray-600 text-xs text-center mb-1.5 sm:mb-2 px-2 sm:px-3 italic leading-snug line-clamp-2">
                      {member.skills}
                    </p>
                    <p className="text-gray-500 text-xs text-center px-2 sm:px-3 leading-snug line-clamp-2 sm:line-clamp-3">
                      {member.description}
                    </p>

                    {/* Social Links */}
                    <div className="flex justify-center gap-2 sm:gap-2.5 mt-2 sm:mt-3">
                      {member.linkedin && (
                        <a
                          href={member.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-[#4299f5] hover:bg-[#3a8fe5] text-white transition-all duration-300 transform hover:scale-110 shadow-lg"
                          aria-label={`${member.name} LinkedIn`}
                        >
                          <FaLinkedin size={13} className="sm:w-3.5 sm:h-3.5" />
                        </a>
                      )}
                      {member.instagram && (
                        <a
                          href={member.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-[#4299f5] hover:bg-[#3a8fe5] text-white transition-all duration-300 transform hover:scale-110 shadow-lg"
                          aria-label={`${member.name} Instagram`}
                        >
                          <FaInstagram size={13} className="sm:w-3.5 sm:h-3.5" />
                        </a>
                      )}
                      {member.email && (
                        <a
                          href={`mailto:${member.email}`}
                          className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-[#4299f5] hover:bg-[#3a8fe5] text-white transition-all duration-300 transform hover:scale-110 shadow-lg"
                          aria-label={`Email ${member.name}`}
                        >
                          <HiMail size={13} className="sm:w-3.5 sm:h-3.5" />
                        </a>
                      )}
                    </div>
                  </div>

                  {/* Spacer to push glow & keep uniform height */}
                  <div className="mt-auto pt-4"></div>

                  {/* Decorative bottom glow */}
                  <div className="absolute left-1/2 -bottom-4 -translate-x-1/2 w-24 h-6 bg-[#4299f5] opacity-20 blur-md rounded-full"></div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        {/* Decorative Quote */}
        <div className="mt-12">
          <blockquote className="text-xl italic text-gray-700 font-semibold" style={{fontFamily: 'Montserrat, sans-serif'}}>
            “Great teams build great dreams.”
          </blockquote>
        </div>
      </div>
    </section>
      {/* Core Values */}
      <section className="bg-gray-50 py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-12 animate-fade-in-up" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Our Core <span className="text-[#4299f5]">Values</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 animate-fade-in-up delay-200">
            {[
              { title: "Innovation", desc: "Constantly pushing boundaries" },
              { title: "Collaboration", desc: "Teamwork makes the dream work" },
              { title: "Excellence", desc: "Quality in everything we do" },
              { title: "Customer First", desc: "Your success is our priority" }
            ].map((value, idx) => (
              <div key={idx} className="text-center p-6 rounded-xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border-2 border-transparent hover:border-[#4299f5]">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>{value.title}</h3>
                <p className="text-base text-gray-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Our Team CTA */}
      <section className="bg-gray-50 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-[#4299f5] via-[#3a8fe5] to-[#2d7dd1] rounded-xl p-6 sm:p-8 lg:p-12 shadow-2xl">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4 sm:mb-6" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Want to Join Our Team?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto">
            We're always looking for talented individuals passionate about technology and hospitality
          </p>
          <a
            href="/careers"
            className="inline-block px-6 py-3 sm:px-8 sm:py-3.5 lg:px-10 lg:py-4 bg-white text-[#4299f5] text-base sm:text-lg font-bold rounded-full shadow-2xl hover:shadow-white/50 transition-all duration-300 transform hover:scale-105" style={{fontFamily: 'Montserrat, sans-serif'}}
          >
            View Open Positions
          </a>
        </div>
      </section>
    </div>  );
}

export default Team;
